import CountUp from 'react-countup';

const stats = [
  { label: 'People Reached', value: 2000000 },
  { label: 'Projects Launched', value: 120 },
  { label: 'Countries Served', value: 45 },
];

const ImpactStats = () => {
  return (
    <section className="py-16 bg-gray-100 text-center">
      <h2 className="text-3xl font-semibold mb-8">Our Impact</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
        {stats.map((stat, idx) => (
          <div key={idx}>
            <h3 className="text-5xl font-bold text-red-600">
              <CountUp end={stat.value} duration={2} separator="," />
            </h3>
            <p className="mt-2 text-gray-600">{stat.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ImpactStats